// extracted by mini-css-extract-plugin
export default {"dialog-content":"dialog-content__kFQ1X","label":"label__Ksg0O","input":"input__XLsIa","highlight":"highlight__HVE9w","actions":"actions__kpe-U"};